import { PrimitiveValueObject } from './primitive-value-object.model';

export abstract class IdValueObject extends PrimitiveValueObject<string> {}
